import { useContext } from "react";
import { IUseCalendarReturn } from "@hooks/useCalendar";
import useFocus from "@hooks/useFocus";
import { FiltersContext } from "providers/FiltersProvider";
import DatePicker from "react-datepicker";
import BackDrop from "./common/BackDrop";
import Button from "./common/Button";
import { LOCAL_STORAGE } from "./utils/constants";
import dateRangePickerConfigNamu from "./utils/dateRangePickerConfigNamu";

import "react-datepicker/dist/react-datepicker.css";
import dayjs, { Dayjs } from 'dayjs'


interface ICalendarPopUpHomePageProps
  extends Pick<
    IUseCalendarReturn,
    | "monthsShown"
    | "setStartDate"
    | "setEndDate"
    | "calendarStatus"
    | "setCalendarStatus"
    | "resetToLastValues"
  > {
  counter: number;
  handleSearch: () => void;
  isOnRequestQuote?: boolean;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  isOnResultsPage?: boolean;
}

const CalendarPopUpHomePage = (
    props: ICalendarPopUpHomePageProps
  ): JSX.Element | null => {
    const filtersContext = useContext(FiltersContext);

    const focusRef = useFocus();

    const populateLocalStorageDates = (
      currentStartDate: Dayjs | null,
      currentEndDate: Dayjs | null
    ): void => {
      if (props.isOnRequestQuote) {
        localStorage.setItem(
          LOCAL_STORAGE.userSearchQueryParams,
          JSON.stringify({
            startDate: currentStartDate?.format("YYYY-MM-DD"),
            endDate: currentEndDate?.format("YYYY-MM-DD"),
          })
        );
        props.setCalendarStatus(false);
      }
    };

    const onDatesUpdate = (dates: [Date | null, Date | null]): void => {
      const [startDate, endDate] = dates.map(dt => dt ? dayjs(dt) : null);
      props?.setStartDate(startDate);
      props?.setEndDate(endDate);

      if (startDate && endDate) {
        populateLocalStorageDates(startDate, endDate);
        filtersContext?.changeCalendarSelection(true);
      }
    };

    if (!props.calendarStatus) {
      return null;
    }

    return (
      <>
        <div className="fixed h-screen w-screen">
          <BackDrop
            closeModalHandler={() => {
              props.resetToLastValues();
              props.setCalendarStatus(false);
            }}
          />
        </div>
        <div
          id="calendar_popup"
          tabIndex={0}
          ref={focusRef}
          className={`absolute left-[-200%] top-[100%] z-[50] h-[320px] w-[520px] rounded-3xl bg-white drop-shadow-2xl focus:outline-none`}
        >
          <div className="absolute left-5 top-[1.5rem] h-full w-full">
            <DatePicker
              {...dateRangePickerConfigNamu}
              monthsShown={props.monthsShown}
              selectsRange
              startDate={props.startDate?.toDate()}
              endDate={props.endDate?.toDate()}
              onChange={onDatesUpdate}
            />
          </div>
          <div className="absolute left-0 bottom-0 w-full">
            {filtersContext?.calendarUtils.inputDate && (
              <Button
                variant="no-outline"
                onClick={(e) => {
                  filtersContext.calendarUtils.resetValues();
                  filtersContext.changeCalendarSelection(false);
                }}
              >
                Clear&nbsp;Dates
              </Button>
            )}
          </div>
        </div>
      </>
    );
  }
;

export default CalendarPopUpHomePage;
